import { Component, ChangeDetectionStrategy, OnInit, inject, effect, signal } from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { ActivatedRoute, RouterOutlet } from "@angular/router";
import { OidcService } from "@fry/lib/core";
import { PortalMenuComponent } from "./portal-menu.component";
import { VersionInformationComponent } from "@fry/components/common/version-information.component";
import { map } from "rxjs";
import { toSignal } from "@angular/core/rxjs-interop";
import { ClusterService } from "@fry/lib/core/cluster.service";
import { PortalService } from "./portal.service";
import { Dashboard } from "@fry/dashboards/lib";
import { BoardComponent } from "@fry/boards/components";
import { BOARD_CARD_TYPE, BoardCardRegistryService } from "@fry/boards/lib";
import { TextCard } from "@fry/components/common/text-card/text-card";
import { BookingAvailableCard } from "@fry/booking/components/bookings/booking-available-card/booking-available-card";
import { AppLoadService } from "@fry/lib/appload/appload.service";

@Component({
  selector: "app-portal",
  templateUrl: './portal.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet,
    MatCardModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    PortalMenuComponent,
    VersionInformationComponent,
    BoardComponent,
  ],
  providers: [
    { provide: BOARD_CARD_TYPE, multi: true, useValue: TextCard },
    { provide: BOARD_CARD_TYPE, multi: true, useValue: BookingAvailableCard },
    BoardCardRegistryService
  ]
})
export class PortalComponent implements OnInit {

  portal = inject(PortalService);
  route = inject(ActivatedRoute);
  oidc = inject(OidcService);
  cluster = inject(ClusterService);
  appLoadService = inject(AppLoadService);
  loaded = signal<boolean>(false);
  error = signal<string|null>(null);
  $org = toSignal(this.route.paramMap.pipe(
  map(params => `org_${params.get('org')}`)
  ));
  $portalId = toSignal(this.route.paramMap.pipe(
  map(params => params.get('portal'))
  ));

  $dashboard = signal<Dashboard | null>(null);

  currentUser = this.oidc.currentUser;
  apiInfo = this.oidc.apiInfo;

  constructor() {
  effect(() => {
    const org = this.$org() || null;
    this.oidc.setOrganisation(org, { noPreserve: true });
    console.log(this.$org());
  });

  }

  async ngOnInit() {
  console.info('InitializeApp:: start init process');
  const user = await this.oidc.init({ relogin: false })
  if (user === null) {
    // await this.cluster.loadProfileOrganisations();
    const org = this.$org();
    if (org) {
    try {
      await this.cluster.loadOrganisation(org);
    } catch (e) {
      console.error(e);
      this.error.set(e.message
      ? e.message
      : 'Failed to load organisation');
    }
    }
  } else {
    await this.appLoadService.initializeApp();
  }


  const portalId = this.$portalId();
  if (!portalId) {
    throw new Error('No portal id provided');
  }

  try {
    const dashboard = await this.portal.get(portalId);
    this.$dashboard.set(dashboard);
  } catch (e) {
    console.log(e);
    this.error.set(e.message);
  }
  console.log(user);
  this.loaded.set(true);
  }

}